import styled from 'styled-components';

interface IContainerProps {
    marginTop?: string;
}

export const Container = styled.div<IContainerProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    justify-content: center;
    background-color: #efefef;
    padding: 5px;
    margin-top: ${props => props.marginTop || '5px'};

    @media screen and (max-width: 700px) {
        background-color: transparent;
    }
`

export const Filter = styled.span`
    padding: 5px;
    border: 1px solid #fff;
    border-radius: 7px;
    margin-right: 5px;
    background-color: #fff;
    font-size: 0.8em;

    @media screen and (max-width: 700px) {
        padding: 2px 5px;
        font-size: 0.7em;
        max-width: 90px;
        overflow-wrap: break-word;
    }
`

export const FilterName = styled.span`
    font-weight: bold;
`

export const FilterValue = styled.span`
`

export const Title = styled.div`
    font-size: 0.9em;
    font-weight: bold;
    margin-bottom: 0px;
    color: #888;

    @media screen and (max-width: 700px) {
        display: none;
    }
`

export const Filters = styled.div`
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: start;
    overflow-x: auto;

    @media screen and (max-width: 700px) {
        max-width: 98vw;
    }
`